@let player = squadPlayer(); @if (player) {
<div class="player-tile">
  <div class="player-tile-number">
    <div>
      @if (player.number) {
      {{ player.number }}
      } @else { &nbsp; }
    </div>
  </div>
  <div class="player-tile-image-container">
    @if (player.image) {
    <img class="player-tile-image" [src]="player.image | imageVariant" />
    } @else {
    <app-icon name="player-outline" class="player-tile-image-placeholder"></app-icon>
    }
  </div>
  <div class="player-tile-info">
    <div class="player-tile-name">
      <div class="player-tile-first-name">{{ player.first_name }}</div>
      <div class="player-tile-surname">{{ player.last_name }}</div>
    </div>
    <div class="player-tile-position">
      {{ 'team.position.' + player.position | translate }}
    </div>
  </div>
</div>
} @else {
<div class="player-tile player-tile-skeleton">
  <div class="player-tile-number">
    <div></div>
  </div>
  <div class="player-tile-image-container">
    <app-icon
      name="player-outline"
      class="player-tile-image-placeholder player-tile-image-placeholder-skeleton"
    ></app-icon>
  </div>
  <div class="player-tile-info">
    <div class="player-tile-name">
      <div class="player-tile-first-name"></div>
      <div class="player-tile-surname"></div>
    </div>
    <div class="player-tile-position"></div>
  </div>
</div>
}
